import genericCustomAppEventEventHandler from "analytics/genericCustomAppEventHandler";
import { CUSTOM_APP_EVENT_NAMES } from "../customAppEventNames";
import {
  IViewScreenParams,
  IViewPopUpParams,
  IClickPopUpButtonParams,
  IClickButtonParams,
  ICompleteStoreDetails,
  IChooseStoreFormat,
  ISavePin,
  ICompleteStoreAddress,
  ICompleteStoreProfile,
  ISuccessOTP,
  IIncorrectOTP,
  ISubmitTermsConfirmation,
  ICompleteIbangNegosyoSurvey,
  IClickItemCard,
  IClosePopUp,
  IClickCRMBanner,
  IViewCRMBanner,
  ISubmitSecurityQuestion,
} from "interfaces/CustomAppEvents/customAppEventsParams.interface";

const trackViewScreen = (parameters: IViewScreenParams) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.view_screen, parameters);
};

const trackViewPopUp = (parameters: IViewPopUpParams) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.view_popup, parameters);
};

const trackClickPopUpButton = (parameters: IClickPopUpButtonParams) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.click_popup_button, parameters);
};

const trackClickButton = (parameters: IClickButtonParams) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.click_button, parameters);
};

const trackCompleteStoreDetails = (parameters: ICompleteStoreDetails) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.complete_store_details, parameters);
};

const trackChooseStoreFormat = (parameters: IChooseStoreFormat) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.choose_store_format, parameters);
};

const trackSavePin = (parameters: ISavePin) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.save_pin, parameters);
};

const trackCompleteStoreAddress = (parameters: ICompleteStoreAddress) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.complete_store_address, parameters);
};

const trackICompleteStoreProfile = (parameters: ICompleteStoreProfile) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.complete_store_profile, parameters);
};

const trackSuccessOTP = (parameters: ISuccessOTP) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.success_otp, parameters);
};

const trackIncorrectOTP = (parameters: IIncorrectOTP) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.incorrect_otp, parameters);
};

const trackSubmitTermsConfirmation = (parameters: ISubmitTermsConfirmation) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.submit_terms_confirmation, parameters);
};

const trackCompleteIbangNegosyoSurvey = (parameters: ICompleteIbangNegosyoSurvey) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.complete_ibang_negosyo_survey, parameters);
};

const trackClickItemCard = (parameters: IClickItemCard) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.click_item_card, parameters);
};

const trackClosePopUp = (parameters: IClosePopUp) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.close_popup, parameters);
};

const trackClickCRMBanner = (parameters: IClickCRMBanner) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.click_CRM_banner, parameters);
};

const trackViewCRMBanner = (parameters: IViewCRMBanner) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.view_CRM_banner, parameters);
};

const trackSubmitSecurityQuestion = (parameters: ISubmitSecurityQuestion) => {
  genericCustomAppEventEventHandler(CUSTOM_APP_EVENT_NAMES.submit_security_questions, parameters);
};

export {
  trackViewPopUp,
  trackViewScreen,
  trackClickPopUpButton,
  trackClickButton,
  trackCompleteStoreDetails,
  trackChooseStoreFormat,
  trackSavePin,
  trackCompleteStoreAddress,
  trackICompleteStoreProfile,
  trackSuccessOTP,
  trackIncorrectOTP,
  trackSubmitTermsConfirmation,
  trackCompleteIbangNegosyoSurvey,
  trackClickItemCard,
  trackClosePopUp,
  trackClickCRMBanner,
  trackViewCRMBanner,
  trackSubmitSecurityQuestion,
};
